<svg
  width="33"
  height="34"
  viewBox="0 0 33 34"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <g clip-path="url(#clip0_86_5321)">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3.23642 2.94281C1.6486 2.94281 0.36142 4.22999 0.36142 5.81781V28.1822C0.36142 29.77 1.6486 31.0572 3.23642 31.0572H29.7636C31.3514 31.0572 32.6386 29.77 32.6386 28.1822V5.81781C32.6386 4.22999 31.3514 2.94281 29.7636 2.94281H3.23642ZM2.11142 5.81781C2.11142 5.19649 2.6151 4.69281 3.23642 4.69281H29.7636C30.3849 4.69281 30.8886 5.19649 30.8886 5.81781V28.1822C30.8886 28.8035 30.3849 29.3072 29.7636 29.3072H3.23642C2.6151 29.3072 2.11142 28.8035 2.11142 28.1822V5.81781ZM5.33246 6.15733C4.29692 6.15733 3.45746 6.9968 3.45746 8.03233V25.9676C3.45746 27.0032 4.29692 27.8426 5.33246 27.8426H27.6675C28.7031 27.8426 29.5425 27.0032 29.5425 25.9676V8.03233C29.5425 6.9968 28.7031 6.15733 27.6675 6.15733H5.33246ZM5.20746 8.03233C5.20746 7.9633 5.26342 7.90733 5.33246 7.90733H27.6675C27.7366 7.90733 27.7925 7.9633 27.7925 8.03233V25.9676C27.7925 26.0367 27.7366 26.0926 27.6675 26.0926H5.33246C5.26342 26.0926 5.20746 26.0367 5.20746 25.9676V8.03233Z"
      fill="currentColor"
    />
  </g>
  <defs>
    <clipPath id="clip0_86_5321">
      <rect width="33" height="33" fill="white" transform="translate(0 0.5)" />
    </clipPath>
  </defs>
</svg>
